/**
 * Seed.Import
 */


define('Seed.Import',['jquery', "lib", 'Seed', 'bootbox', 'uploadController'], function ($, lib, Seed, bootbox) {
    'use strict';

    Seed.Import = {
        /**
         * Creation d'un template
         */
        Create: function () {
            var template = $("#ImportModelName").val();
            var nomtable = $("#ImportModelTable").val();

            if ($("#ImportModelName").val() === "") {
                bootbox.alert(MSG_EMPTY_CODE);
                return false;
            }

            Seed.Ajax.Post({
                url: "_module/ImportFichier/Import.CreateTemplate.php",
                data: "&template=" + template +
                        "&nomtable=" + nomtable,
                json: true,
                async: true,
                success: function (xml) {
                    if (xml.retour === 'ok') {
                        Seed.Tab.Reload();
                        Seed.Import.Show(template);

                        $('#ImportModelDetail').css('display', 'none');
                        $('#activeAdvencedMode').prop('checked', true);
                        Seed.Import.showHide();
                        $('#ImportModelSelected').val(template);
                    } else {
                        bootbox.alert(xml.retour);
                    }
                }
            });
        },
        /**
         * Suppression d'un template
         */
        Delete: function () {
            var template = $("#ImportModelSelected").val();
            Seed.Ajax.Post({
                url: "_module/ImportFichier/Import.DeleteTemplate.php",
                data: "&template=" + template,
                success: function () {

                    //Seed.Tab.Reload();

                    $("#ImportModelSelected option").filter(function () {
                        //may want to use $.trim in here
                        return $(this).text() === template;
                    }).css('display', 'none');

                    $("#ImportModelSelected").val('');
                    $('#ImportModelDetail').css('display', 'none');
                }
            });
        },
        /**
         * Affichage de la définition d'un template
         * @param ModelName Nom du template
         */
        Show: function (ModelName) {
            var table = 'none';
            if ($('#activeAdvencedMode option').prop('checked')) {
                var table = 'block';
            }

            var xml = Seed.Ajax.Post({
                url: "_module/ImportFichier/ModeleDetail.php",
                data: "&template=" + ModelName + "&table=" + table,
                json: true
            });

            $("#ImportModelDetail").html(xml.html);

            var jscript = document.createElement("SCRIPT");
            jscript.text = xml.script;
            Seed.Tab.GetFrame().append(jscript);

            $('#ImportModelDetail').css('display', 'block');

            if ($('#activeAdvencedMode').prop('checked')) {
                $('#upload-config').css('display', 'block');
                $('#moreAdvancedConfig').css('display', 'block');
            }
        },
        Init: function (Template) {
            $(".Seed_Import_Structure").sortable({
                containment: "#upload-config",
                /**
                 * Appelé sur le changement d'ordre d'un element de la liste Ou sur la suppression d'un element dans la liste
                 * @param  e
                 * @param  ui
                 */
                update: function (e, ui) {

                    if (this === ui.item.parent()[0]) {
                        var pos = "";
                        var cur = 1;

                        $(".Seed_Import_Champ").not(".Seed_Import_Disponible").each(function () {
                            pos += "&" + $(this).attr("id") + "=" + cur;
                            cur++;
                        });

                        Seed.Ajax.Post({
                            url: "_module/ImportFichier/Import.UpdateStructure.php",
                            data: "template=" + Template + pos,
                            success: function () {
                                Seed.Import.Show(Template);
                                Seed.Import.backToAnchor();
                            }
                        });
                    }
                },
                /**
                 * Appelé lors de la reception (ajout) d'un element dans la liste
                 * @param  event
                 * @param  ui
                 */
                receive: function (event, ui) {
                    var pos = "";
                    var cur = 1;

                    $(this.children).each(function () {

                        if (lib.empty($(this).attr("id"))) {
                            pos += "&" + $(ui.item[0]).attr("id") + "=" + cur;
                        } else {
                            pos += "&" + $(this).attr("id") + "=" + cur;
                        }
                        cur++;
                    });

                    Seed.Ajax.Post({
                        url: "_module/ImportFichier/Import.UpdateStructure.php",
                        data: "template=" + Template + pos,
                        success: function () {
                            Seed.Import.Show(Template);
                            Seed.Import.backToAnchor();
                        }
                    });
                }
            });

            $('.Seed_Import_Disponible').draggable({
                containment: "#upload-config",
                connectToSortable: '.Seed_Import_Structure',
                helper: 'clone',
                delay: 0,
                distance: 0
            });

            $('.Seed_Import_Trash').droppable({
                accept: '.Seed_Import_Champ',
                tolerance: 'pointer',
                over: function (event, ui) {

                    $(this).css('background-color', 'lightgreen');
                }
                ,
                out: function (event, ui) {

                    $(this).css('background-color', 'white');
                }
                ,
                drop: function (event, ui) {

                    $(this).css('background-color', 'white');
                    ui.draggable.remove();
                    Seed.Ajax.Post({
                        url: "_module/ImportFichier/Import.DeleteField.php",
                        data: "&nomchamp=" + ui.draggable.attr("id") + "&template=" + Template,
                        success: function () {
                            Seed.Import.Show(Template);
                            Seed.Import.backToAnchor();
                        }
                    });
                }
            });
        },
        SetKey: function (Template, Field, Value) {
            Seed.Ajax.Post({
                url: "_module/ImportFichier/Import.SetKey.php",
                data: "&nomchamp=" + Field + "&template=" + Template + "&value=" + Value,
                success: function () {
                    Seed.Import.Show(Template);
                    Seed.Import.backToAnchor();
                }
            });
        },
        setDelimiter: function (template, delimiter) {
            if (delimiter !== "") {
                Seed.Ajax.Post({
                    url: "_module/ImportFichier/Import.SetDelimiter.php",
                    data: "&template=" + template + "&delimiter=" + delimiter
                });
            } else {
                bootbox.alert(LBL_NO_EMPTY_DATA);
            }
        },
        setDateFormat: function (template, newDateFormat) {
            if (newDateFormat !== "") {
                Seed.Ajax.Post({
                    url: "_module/ImportFichier/Import.SetDateFormat.php",
                    data: "&template=" + template + "&newDate=" + newDateFormat
                });
            } else {
                bootbox.alert(MSG_IMPOSSIBLE_ACTION);
            }
        },
        setSkipHeader: function (template, newSkipHeaderValue) {
            if (newSkipHeaderValue !== "") {
                Seed.Ajax.Post({
                    url: "_module/ImportFichier/Import.SetSkipHeader.php",
                    data: "&template=" + template + "&skipHeader=" + newSkipHeaderValue
                });
            } else {
                bootbox.alert(MSG_IMPOSSIBLE_ACTION);
            }
        },
        setConsistencyTest: function (template, newAcceptance) {
            if (newAcceptance !== "") {
                Seed.Ajax.Post({
                    url: "_module/ImportFichier/Import.SetConsistencyTest.php",
                    data: "&template=" + template + "&newAcceptance=" + newAcceptance
                });
            } else {
                bootbox.alert(MSG_IMPOSSIBLE_ACTION);
            }
        },
        Success: function (file, serverData) {
            try {
                var progress = new FileProgress(file, this.customSettings.progressTarget);
                if (serverData != "") {
                    progress.setStatus("Erreur Import: " + serverData);
                } else {
                    progress.setComplete();
                    progress.setStatus("Import terminé.");
                    progress.toggleCancel(false);
                }
            } catch (ex) {
                this.debug(ex);
            }
        },
        OfficeToTech: function () {
            $('#message-synchro').html('');
            Seed.Ajax.Post({
                url: "_module/ImportFichier/ImportExport.OfficeToTech.php",
                data: "",
                success: function (xml) {
                    eval(xml);
                }
            });
        },
        TechToOffice: function () {
            $('#message-synchro').html('');
            Seed.Ajax.Post({
                url: "_module/ImportFichier/ImportExport.TechToOffice.php",
                data: "",
                success: function (xml) {
                    eval(xml);
                }
            });
        },
        /**
         * Retour vers une ancre
         */
        backToAnchor: function () {
            location.hash = "#upload-config";
            location.hash = 'noHash';
        },
        /**
         * Activer ou désactiver les paramètres avancé
         */
        showHide: function () {
            if (document.getElementById('activeAdvencedMode').checked) {
                $('#model-creation').show();
                $('#delete-button').show();

                if (document.getElementById('upload-config')) {
                    $('#upload-config').show();
                }

                if (document.getElementById('moreAdvancedConfig')) {
                    $('#moreAdvancedConfig').show();
                }
            } else {
                $('#model-creation').hide();
                $('#delete-button').hide();

                if (document.getElementById('upload-config')) {
                    $('#upload-config').hide();
                }

                if (document.getElementById('moreAdvancedConfig')) {
                    $('#moreAdvancedConfig').hide();
                }
            }
        },
        /**
         * Active le mode avancé
         */
        getAdvencedParam: function () {
            $("#hiddenDateFormat").val($("#formatDate").val());
            $("#hiddenDelimiter").val($("#delimiter").val());
            var skipHeaderVal = Seed.Tab.GetFrame().find("#skipHeader").attr('checked') === 'checked' ? 1 : 0;
            var paramConsistencyVal = Seed.Tab.GetFrame().find("#paramConsistency").attr('checked') === 'checked' ? 1 : 0;
            $("#hiddenSkipHeader").val(skipHeaderVal);
            $("#hiddenConsistencyTest").val(paramConsistencyVal);
        }
    };
});

